import type { VNode } from "vue";
import Vue from "vue";
import ColumnFilterComponent from "@/components/controls/grid/columnfilters/ColumnFilterComponent.vue";
import type { CreateElement } from "vue/types/vue";
import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";

/**
 * Performs filtering with text. Note. these are not taking into account locales differences.
 */
const textFilterTypes: FilterType[] = [
  {
    type: "filter_contains",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: string) =>
      !!formattedItemValue &&
      formattedItemValue
        .toString()
        .toUpperCase()
        .indexOf(filterValue.toUpperCase()) !== -1,
  },
  {
    type: "filter_not_contains",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: string) =>
      !!formattedItemValue &&
      formattedItemValue
        .toString()
        .toUpperCase()
        .indexOf(filterValue.toUpperCase()) === -1,
  },
  {
    type: "filter_starts_with",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: string) =>
      !!formattedItemValue &&
      formattedItemValue
        .toString()
        .toUpperCase()
        .startsWith(filterValue.toUpperCase()),
  },
  {
    type: "filter_ends_with",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: string) =>
      !!formattedItemValue &&
      formattedItemValue
        .toString()
        .toUpperCase()
        .endsWith(filterValue.toUpperCase()),
  },
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: string) =>
      !!formattedItemValue &&
      formattedItemValue.toString().toUpperCase() === filterValue.toUpperCase(),
  },
  {
    type: "filter_not_equals",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: string) =>
      !!formattedItemValue &&
      formattedItemValue.toString().toUpperCase() !== filterValue.toUpperCase(),
  },
];

export function buildApplyTextFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, textFilterTypes);
}

export default Vue.extend({
  name: "TextFilterComponent",
  components: { ColumnFilterComponent },
  render(h: CreateElement): VNode {
    return h(ColumnFilterComponent, {
      attrs: { ...this.$attrs },
      props: { filterTypes: textFilterTypes },
    });
  },
});
